import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Radio, Space, Typography } from 'antd';
import CampaignRequestorAudienceDialog from './CampaignRequestorAudienceDialog';
import { CampaignRequestorAudienceTable } from './CampaignRequestorAudienceTable';

const { Text } = Typography;

export const CampaignRequestorAudience = ({
  form,
  index,
  campaignIndex,
  fieldKey,
  restField,
  name,
  setPreviousValues,
  editable = true,
}) => {
  const campaigns = form.getFieldValue('campaigns') || [];
  const isRegulated = form.getFieldValue('isRegulated');
  const lineItem = campaigns?.[campaignIndex]?.lineItems?.[index] || {};
  const firstPartyDataAudiences = lineItem.firstPartyDataAudiences || [];

  const [showFirstPartyDataModal, setShowFirstPartyDataModal] = useState(false);
  const [audienceType, setAudienceType] = useState(lineItem.audienceType || null);

  useEffect(() => {
    setTimeout(() => {
      setAudienceType(form.getFieldValue(['campaigns', campaignIndex, 'lineItems', index, 'audienceType']));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return (
    <>
      <Card title="AUDIENCE">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Text>Audience type for this line item:</Text>
          <Form.Item
            {...restField}
            name={[name, 'audienceType']}
            fieldKey={[fieldKey, 'audienceType']}
            rules={[
              {
                required: true,
                message: 'Please select an audience type',
              },
            ]}
          >
            <Radio.Group
              disabled={!editable}
              value={audienceType}
              onChange={(e) => {
                const newAudienceType = e.target.value;

                // Clear first party data audiences when switching away from FIRST_PARTY_DATA
                if (audienceType === 'FIRST_PARTY_DATA' && newAudienceType !== 'FIRST_PARTY_DATA') {
                  const updatedCampaigns = [...campaigns];

                  if (updatedCampaigns[campaignIndex]?.lineItems?.[index]) {
                    updatedCampaigns[campaignIndex] = {
                      ...updatedCampaigns[campaignIndex],
                      lineItems: updatedCampaigns[campaignIndex].lineItems.map((item, idx) =>
                        idx === index ? { ...item, firstPartyDataAudiences: [] } : item
                      ),
                    };

                    form.setFieldsValue({ campaigns: updatedCampaigns });

                    if (setPreviousValues) {
                      setPreviousValues({
                        campaigns: updatedCampaigns[campaignIndex].lineItems,
                      });
                    }
                  }
                }

                setAudienceType(newAudienceType);
              }}
            >
              <Space direction="vertical">
                <Radio value="FIRST_PARTY_DATA">First Party Data</Radio>
                {/* <Radio value="THIRD_PARTY_DATA">Third Party Data</Radio> */}
                <Radio value="ALL_USERS">
                  All users in targeting area {isRegulated ? 'aged 21+' : ''}
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Space>
        {audienceType === 'FIRST_PARTY_DATA' && (
          <CampaignRequestorAudienceTable
            name={name}
            restField={restField}
            fieldKey={fieldKey}
            setShowFirstPartyDataModal={setShowFirstPartyDataModal}
            editable={editable}
            form={form}
            index={index}
            campaignIndex={campaignIndex}
            audienceType={audienceType}
            setPreviousValues={setPreviousValues}
          />
        )}

        {/* Create hidden input for firstPartyDataAudiences */}
        <Form.Item
          {...restField}
          name={[name, 'firstPartyDataAudiences']}
          fieldKey={[fieldKey, 'firstPartyDataAudiences']}
          hidden
          rules={[
            {
              required: audienceType === 'FIRST_PARTY_DATA',
              message: 'Please select a at least one first party audience',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Card>

      {showFirstPartyDataModal && (
        <CampaignRequestorAudienceDialog
          visible={showFirstPartyDataModal}
          setVisible={setShowFirstPartyDataModal}
          orgId={form.getFieldValue('advertiserId')}
          selectedAudiences={firstPartyDataAudiences}
          onAddSelections={(audiences) => {
            const updatedCampaigns = [...campaigns];

            if (updatedCampaigns[campaignIndex]?.lineItems?.[index]) {
              const processedAudiences = audiences.map((audience) => {
                // Check if audience already exists in the list
                const existingAudience = firstPartyDataAudiences.find(
                  (a) => a.name === audience.name
                );

                if (existingAudience) {
                  return existingAudience;
                }

                delete audience.id;
                return audience;
              });

              updatedCampaigns[campaignIndex] = {
                ...updatedCampaigns[campaignIndex],
                lineItems: updatedCampaigns[campaignIndex].lineItems.map((item, idx) =>
                  idx === index ? { ...item, firstPartyDataAudiences: processedAudiences } : item
                ),
              };

              form.setFieldsValue({
                campaigns: updatedCampaigns,
              });

              setPreviousValues({
                campaigns: updatedCampaigns[campaignIndex].lineItems,
              });
            }
          }}
        />
      )}
    </>
  );
};
